import React from "react";
import { Button } from "@fluentui/react-components";
import { Delete20Regular } from "@fluentui/react-icons";
import { formatCurrency } from "../../utils/currency";

export default function DynamicsTable({
  title,
  rows = [],
  currency = "DKK",
  onAdd,
  onRemove,
  onChange,
}) {
  return (
    <section className="mb-6 overflow-hidden rounded-sm border border-[#edebe9] bg-white shadow-sm">
      <div className="flex h-11 items-center justify-between border-b border-[#edebe9] bg-[#faf9f8] px-4">
        <h2 className="text-sm font-semibold text-[#201f1e]">{title}</h2>

        <Button size="small" appearance="primary" onClick={onAdd}>
          + Add
        </Button>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full border-collapse text-[13px]">
          <thead>
            <tr className="h-8 border-b border-[#edebe9] bg-[#f3f2f1] text-left text-xs font-semibold uppercase tracking-wide text-[#605e5c]">
              <th className="w-[42%] px-2">Label</th>
              <th className="w-[90px] px-2">Qty</th>
              <th className="w-[80px] px-2">Unit</th>
              <th className="w-[120px] px-2">Unit price</th>
              <th className="w-[130px] px-2 text-right">Total</th>
              <th className="w-[56px] px-2 text-right"></th>
            </tr>
          </thead>

          <tbody className="divide-y divide-[#edebe9]">
            {rows.map((row, index) => (
              <tr
                key={row.id || index}
                className={`h-8 hover:bg-[#f3f2f1] ${
                  index % 2 === 0 ? "bg-white" : "bg-[#faf9f8]"
                }`}
              >
                <td className="px-2 text-[#323130]">
                  <input
                    value={row.label || ""}
                    onChange={(e) =>
                      onChange(index, "label", e.target.value)
                    }
                    className="w-full rounded-sm border border-transparent bg-transparent px-1 text-[13px] focus:border-[#0f6cbd] focus:bg-white focus:outline-none"
                    placeholder="Label"
                  />
                </td>

                <td className="px-2 text-[#323130]">
                  <input
                    type="number"
                    value={row.quantity ?? 0}
                    onChange={(e) =>
                      onChange(
                        index,
                        "quantity",
                        e.target.value === "" ? 0 : Number(e.target.value)
                      )
                    }
                    className="w-full rounded-sm border border-transparent bg-transparent px-1 text-[13px] focus:border-[#0f6cbd] focus:bg-white focus:outline-none"
                  />
                </td>

                <td className="px-2 text-[#323130]">
                  <input
                    value={row.unit || ""}
                    onChange={(e) =>
                      onChange(index, "unit", e.target.value)
                    }
                    className="w-full rounded-sm border border-transparent bg-transparent px-1 text-[13px] focus:border-[#0f6cbd] focus:bg-white focus:outline-none"
                    placeholder="unit"
                  />
                </td>

                <td className="px-2 text-[#323130]">
                  <input
                    type="number"
                    value={row.unitPrice ?? 0}
                    onChange={(e) =>
                      onChange(
                        index,
                        "unitPrice",
                        e.target.value === "" ? 0 : Number(e.target.value)
                      )
                    }
                    className="w-full rounded-sm border border-transparent bg-transparent px-1 text-[13px] focus:border-[#0f6cbd] focus:bg-white focus:outline-none"
                  />
                </td>

                <td className="px-2 text-right font-medium text-[#323130]">
                  {formatCurrency(row.total || 0, currency)}
                </td>

                <td className="px-2 text-right">
                  <button
                    type="button"
                    onClick={() => onRemove(index)}
                    className="inline-flex h-7 w-7 items-center justify-center rounded-sm text-[#605e5c] hover:bg-[#fde7e9] hover:text-[#a4262c]"
                    title="Remove row"
                  >
                    <Delete20Regular />
                  </button>
                </td>
              </tr>
            ))}

            {rows.length === 0 && (
              <tr>
                <td
                  colSpan={6}
                  className="px-4 py-8 text-center text-sm text-[#605e5c]"
                >
                  No rows yet.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}